<template>
  <footer class="footer">
    <div class="footer-wave"></div>
    <div class="container footer__container">
      <div class="footer__section">
        <div class="footer__social">
          <h3>AATC BRASIL</h3>
          <div class="social-links">
            <a
              href="https://instagram.com/alvineosesquilosbr"
              target="_blank"
              class="social-icon social-icon--instagram"
            >
              <i class="fab fa-instagram"></i>
            </a>
            <a
              href="https://tiktok.com/@alvineosesquilosbr"
              target="_blank"
              class="social-icon social-icon--tiktok"
            >
              <i class="fab fa-tiktok"></i>
            </a>
            <a
              href="https://youtube.com/@alvineosesquilosbr"
              target="_blank"
              class="social-icon social-icon--youtube"
            >
              <i class="fab fa-youtube"></i>
            </a>
          </div>
        </div>
      </div>

      <div class="footer__section">
        <div class="footer__social">
          <h3>Munk Yourself</h3>
          <div class="social-links">
            <a
              href="https://instagram.com/munkyourself"
              target="_blank"
              class="social-icon social-icon--instagram"
            >
              <i class="fab fa-instagram"></i>
            </a>
            <a
              href="https://tiktok.com/@munkyourself"
              target="_blank"
              class="social-icon social-icon--tiktok"
            >
              <i class="fab fa-tiktok"></i>
            </a>
            <a
              href="https://youtube.com/@munkyourself"
              target="_blank"
              class="social-icon social-icon--youtube"
            >
              <i class="fab fa-youtube"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="footer__copyright">
      <div class="container">
        <p>
          {{ $t("footer.disclaimer") }}
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/variables";
@import "../assets/styles/mixins";

.footer {
  background-color: $background-darker;
  color: $white;
  padding: $spacing-xxl 0 0;
  position: relative;
  border-top: 1px solid rgba($white, 0.05);

  .footer-wave {
    position: absolute;
    top: -50px;
    left: 0;
    width: 100%;
    height: 50px;
    background-color: $background-darker;
    clip-path: polygon(
      0 100%,
      100% 100%,
      100% 25%,
      75% 50%,
      50% 25%,
      25% 50%,
      0 25%
    );
    opacity: 0.5;
  }

  &__container {
    display: flex;
    flex-direction: column;
    gap: $spacing-lg;
    position: relative;
    z-index: 2;
    padding-bottom: $spacing-xl;

    @include respond-to(md) {
      flex-direction: row;
      justify-content: space-around;
      align-items: flex-start;
      gap: $spacing-xxl;
    }

    @include respond-to(lg) {
      gap: $spacing-xxxl;
    }
  }

  &__section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: $spacing-md;
    width: 100%;
    text-align: center;
    padding: $spacing-md 0;

    @include respond-to(md) {
      width: auto;
      max-width: 45%;
      gap: $spacing-lg;
      padding: $spacing-lg 0;
    }
  }

  &__social {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: $spacing-sm;

    @include respond-to(md) {
      gap: $spacing-md;
    }

    h3 {
      margin: 0;
      color: $white;
      font-family: $font-secondary;
      font-size: 1.2rem;
      text-transform: uppercase;
      letter-spacing: 2px;
      text-align: center;
      margin-bottom: $spacing-md;
    }

    .social-links {
      display: flex;
      justify-content: center;
      gap: $spacing-md;

      @include respond-to(md) {
        gap: $spacing-lg;
      }
    }
  }

  &__copyright {
    background-color: black;
    padding: $spacing-md 0;
    text-align: center;
    font-size: 0.9rem;
    position: relative;
    z-index: 2;
    margin-top: 0;
    color: $text-muted;

    p {
      padding: 0 $spacing-md;
      margin: 0;
    }
  }
}
</style>
